module.exports = __webpack_public_path__ + "static/media/d5.5fe9019e.jpg";